import { uniqBy } from "lodash";
import { Segment } from "../../types";

export default function createSeatClass(segments: Segment[]) {
  const seatClasses = uniqBy(segments, "seatClass").map(
    (segment) => segment.seatClass
  );
  const isMultiClass = seatClasses.length > 1;

  return {
    seatClasses,
    isMultiClass,
  };
}
